import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SharedForm from '../../../shared/SharedForm';

import AssetFields from './AssetFields';
import FormFieldsPerAssetType from '../shared/FormFieldsPerAssetType';

export default class AssetForm extends Component {

  static propTypes = {
    authToken: PropTypes.string,
    methodType: PropTypes.string,
    actionUrl: PropTypes.string,
    assetTypeVal: PropTypes.string,
    assetName: PropTypes.string,
    assetFieldValues: PropTypes.object,
    currencies: PropTypes.array,
    assetId: PropTypes.number,
    returnUrl: PropTypes.string,
    isRetired: PropTypes.bool,
    isLinked: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {
      assetName: this.props.assetName,
      token: this.props.authToken,
      method: this.props.methodType,
      url: this.props.actionUrl,
      assetType: this.props.assetTypeVal,
      formValid: false,
      requiredFormFields: FormFieldsPerAssetType.fieldsForAsset(this.props.assetName, this.props.isRetired),
      assetFieldValues: this.props.assetFieldValues,
      currencies: this.props.currencies,
      readOnly: false,
      interestRatePercentage: this.defaultInterestRate(this.props.assetTypeVal)
    }
  }

  defaultInterestRate(assetType){
    let interestRate;

    if (this.props.assetFieldValues) {
      interestRate = parseFloat(this.props.assetFieldValues.interestRate);
    } else {
      if (assetType == 'otherIncome') {
        interestRate = this.props.defaultOtherIncomeInterestRate
      }
      else if (assetType == 'investment_property') {
        interestRate = this.props.primeInterestRate
      }
      else {
        interestRate = this.props.defaultMoneyMarketInterestRate
      }
    }

    return (interestRate * 100).toFixed(2);
  }

  mapHttpMethods = (httpMethod) => {
    switch(httpMethod){
      case "PUT":
      case "PATCH":
        return "POST";
      default:
        return httpMethod;
    }
  }

  isFormValid(validStatus){
    this.setState({
      formValid: validStatus
    });
  }

  displayBackButton = () => {
    return this.state.assetFieldValues ? false : true;
  }

  submitButtonText = () => {
    if (this.state.readOnly) return "Loading...";

    if (this.state.method == "POST") {
      return "Add Asset";
    } else {
      return "Save Changes";
    }
  }

  changeAssetInterestRate = (interestRatePercentage) => {
    this.setState({ interestRatePercentage });
  }

  onFormSubmit = (e) => {
    this.setState({ readOnly: true });
  }

  render() {
    return (
      <div className="js-asset-form">
        <SharedForm actionUrl={this.state.url} methodType={this.mapHttpMethods(this.state.method)} authenticityToken={this.state.token}>
          <input type="hidden" name="asset[asset_type]" value={this.state.assetType}></input>
          <input type="hidden" name="asset[interest_rate]" value={this.state.interestRatePercentage / 100}></input>
          <input type="hidden" name="_method" value={this.state.method} />
          <input type="hidden" name="return_url" value={this.props.returnUrl || ""} />
            <AssetFields
              formValidCallback={(validStatus) => this.isFormValid(validStatus)}
              formFieldsToRender={this.state.requiredFormFields}
              changeAssetInterestRate={this.changeAssetInterestRate}
              formFieldValues={this.state.assetFieldValues}
              currencies={this.state.currencies}
              primeInterestRate={this.props.primeInterestRate}
              defaultInterestRate={this.defaultInterestRate(this.state.assetType)}
              defaultMoneyMarketInterestRate={this.props.defaultMoneyMarketInterestRate}
              defaultOtherIncomeInterestRate={this.props.defaultOtherIncomeInterestRate}
              assetId={this.props.assetId}
              isRetired={this.props.isRetired}
              isLinked={this.props.isLinked} />
          <div className='form__actions form__actions--padding'>
            <input type="submit"
                   name="commit"
                   className="button"
                   value={this.submitButtonText()}
                   onClick={this.onFormSubmit}
                   readOnly={this.state.readOnly}
                   disabled={!this.state.formValid}>
            </input>
          </div>
        </SharedForm>
      </div>
    );
  }
}
